<div class="world-builder-container" #modalContainer>
  <!-- Close Button -->
  <button type="button" class="close-button" (click)="onCloseClick()">
    <img src="assets/icons/icon-close.svg" alt="Close">
  </button>


  @switch (currentStep$ | async) {
    @case (1) {
      <app-welcome-step
        (back)="close()"
        (next)="onNextStep()">
      </app-welcome-step>
    }
    @case (2) {
      <app-overview-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-overview-step>
    }
    <!-- Step 3: Upload Map (shown only for new maps without a preset mapId) -->
    @case (3) {
      <app-upload-map-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-upload-map-step>
    }
    @case (4) {
      <app-resource-config-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-resource-config-step>
    }
    @case (5) {
      <app-ai-mode-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-ai-mode-step>
    }
    <!-- Step 5a: Manual confirmation screen -->
    @case ('5a') {
      <app-manual-confirm-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-manual-confirm-step>
    }
    <!-- Step 5b: AI Assisted confirmation and credit verify step -->
    @case ('5b') {
      <app-ai-mode-confirm-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-ai-mode-confirm-step>
    }
    <!-- Step 5c: Guided welcome / credit verify step -->
    @case ('5c') {
      <app-ai-mode-confirm-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-ai-mode-confirm-step>
    }
    <!-- Step 5d: Guided confirmation step -->
    @case ('5d') {
      <app-guided-confirm-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-guided-confirm-step>
    }
    <!-- Step 6: World Identity step -->
    @case (6) {
      <app-world-identity-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-world-identity-step>
    }
    <!-- Step 7: Global Context step -->
    @case (7) {
      <app-global-context-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-global-context-step>
    }
    <!-- Step 7b: Global Context Part 2 step -->
    @case ('7b') {
      <app-global-context-step-2
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-global-context-step-2>
    }
    <!-- Step 7c: Global Context Part 3 step -->
    @case ('7c') {
      <app-global-context-step-3
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-global-context-step-3>
    }
    <!-- Step 7d: Global Context Part 4 step -->
    @case ('7d') {
      <app-global-context-step-4
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-global-context-step-4>
    }
    <!-- Step 8: Cultures step -->
    @case (8) {
      <app-cultures-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-cultures-step>
    }
    <!-- Step 9: Religions step -->
    @case (9) {
      <app-religions-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-religions-step>
    }
    <!-- Step 10: States step -->
    @case (10) {
      <app-states-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-states-step>
    }
    <!-- Step 11: Provinces step -->
    @case (11) {
      <app-provinces-step
        (back)="onPreviousStep()"
        (next)="onNextStep()">
      </app-provinces-step>
    }
    <!-- Step 12: Review / Create step -->
    @case (12) {
      <app-review-create-step
        (back)="onPreviousStep()"
        (create)="onWorldCreated()">
      </app-review-create-step>
    }
  }
</div>
